/**
 * Ilgalaikis turtas: straight-line depreciation by month, from the month after the asset was put into use,
 * until it is written down to its residual value or the month it is disposed of. When the books start later
 * and some depreciation was already written off before them (with the opening balances), the rest is spread
 * over the months left from the books' first month.
 */
const ym = (date) => date.slice(0, 7);
export const addMonths = (month, by) => { const d = new Date(`${month}-01T00:00:00Z`); d.setUTCMonth(d.getUTCMonth() + by); return d.toISOString().slice(0, 7); };
const monthsBetween = (a, b) => (Number(b.slice(0, 4)) - Number(a.slice(0, 4))) * 12 + Number(b.slice(5, 7)) - Number(a.slice(5, 7));
/** The month's depreciation in cents, month by month (YYYY-MM). `booksStart`: the day the books start, if any. */
export function depreciationSchedule(a, booksStart) {
    let first = addMonths(ym(a.inUseFrom), 1);
    let months = a.usefulMonths;
    let total = a.cost - a.residual;
    if (a.depreciatedBefore > 0 && booksStart && ym(booksStart) > first) {
        const elapsed = monthsBetween(first, ym(booksStart));
        first = ym(booksStart);
        months = Math.max(months - elapsed, 1);
        total -= a.depreciatedBefore;
    }
    else if (a.depreciatedBefore > 0) {
        total -= a.depreciatedBefore;
    }
    if (total <= 0)
        return [];
    const last = a.disposedOn ? ym(a.disposedOn) : null;
    const monthly = Math.round(total / months);
    const out = [];
    let left = total;
    for (let i = 0; i < months && left > 0; i++) {
        const month = addMonths(first, i);
        if (last && month > last)
            break;
        const amount = i === months - 1 ? left : Math.min(monthly, left);
        out.push({ month, amount });
        left -= amount;
    }
    return out;
}
/** Defaults for an asset account: its depreciation (amortisation) account and the expense account. */
export function assetDefaults(account) {
    const intangible = account.startsWith('11');
    const contra = account.length >= 4 ? `${account.slice(0, -1)}${intangible ? '8' : '7'}` : account;
    return { depreciation: contra, expense: intangible ? '6307' : '6306' };
}
//# sourceMappingURL=assets.js.map